export default __webpack_public_path__ + "static/media/Contact_Us.39774f70.png";